"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timestamp = void 0;
const IonDecimal_1 = require("../IonDecimal");
const IonTimestamp_1 = require("../IonTimestamp");
const IonTypes_1 = require("../IonTypes");
const FromJsConstructor_1 = require("./FromJsConstructor");
const Value_1 = require("./Value");
const _fromJsConstructor = new FromJsConstructor_1.FromJsConstructorBuilder()
    .withClasses(Date, IonTimestamp_1.Timestamp)
    .build();
/**
 * Represents a timestamp[1] value in an Ion stream.
 *
 * [1] http://amzn.github.io/ion-docs/docs/spec.html#timestamp
 */
class Timestamp extends (0, Value_1.Value)(Date, IonTypes_1.IonTypes.TIMESTAMP, _fromJsConstructor) {
    /**
     * Constructor.
     * @param dateOrTimestamp   A `Date` or `Timestamp` to represent as a timestamp.
     * @param annotations       An optional array of strings to associate with this timestamp.
     */
    constructor(dateOrTimestamp, annotations = []) {
        let date;
        let timestamp;
        if (dateOrTimestamp instanceof Date) {
            date = dateOrTimestamp;
            timestamp = Timestamp._timestampFromDate(date);
        }
        else {
            timestamp = dateOrTimestamp;
            date = timestamp.getDate();
        }
        super(date);
        this._date = date;
        this._timestamp = timestamp;
        this._setAnnotations(annotations);
    }
    static _timestampFromDate(date) {
        const milliseconds = date.getUTCSeconds() * 1000 + date.getUTCMilliseconds();
        const fractionalSeconds = new IonDecimal_1.Decimal(milliseconds, -3);
        // `Date` objects do not store a timezone offset. If the offset is requested
        // via `.getTimezoneOffset()`, the configured offset of the host computer
        // is returned instead of the timezone that was specified when the Date was
        // constructed. Since the timezone of the host may or may not be meaningful
        // to the user, we store the time in UTC instead. Users wishing to store a
        // specific timezone offset on their dom.Timestamp can pass in an IonTimestamp
        // instead of a Date.
        return new IonTimestamp_1.Timestamp(0, date.getUTCFullYear(), date.getUTCMonth() + 1, // Timestamp expects a range of 1-12
        date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), fractionalSeconds);
    }
    timestampValue() {
        return this._timestamp;
    }
    dateValue() {
        return this._date;
    }
    writeTo(writer) {
        writer.setAnnotations(this.getAnnotations());
        writer.writeTimestamp(this.timestampValue());
    }
    _valueEquals(other, options = {
        epsilon: null,
        ignoreAnnotations: false,
        ignoreTimestampPrecision: false,
        onlyCompareIon: true,
    }) {
        let isSupportedType = false;
        let valueToCompare = null;
        // if the provided value is an ion.dom.Symbol instance.
        if (other instanceof Timestamp) {
            isSupportedType = true;
            valueToCompare = other.timestampValue();
        }
        else if (!options.onlyCompareIon) {
            // We will consider other Timestamp-ish types
            if (other instanceof IonTimestamp_1.Timestamp) {
                // expectedValue is a non-DOM Timestamp
                isSupportedType = true;
                valueToCompare = other;
            }
            else if (other instanceof Date) {
                if (this.dateValue().getTime() === other.getTime()) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        if (!isSupportedType) {
            return false;
        }
        if (options.ignoreTimestampPrecision) {
            return this.timestampValue().compareTo(valueToCompare) === 0;
        }
        return this.timestampValue().equals(valueToCompare);
    }
}
exports.Timestamp = Timestamp;
